"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var parser_1 = require("@babel/parser");
var traverse_1 = __importDefault(require("@babel/traverse"));
var generator_1 = __importDefault(require("@babel/generator"));
var types = __importStar(require("@babel/types"));
function dg(path) {
    var node = path.node;
    if (!types.isCallExpression(node))
        return types.jsxText('');
    if (!path.get("callee").toString().endsWith('createElement')) {
        return types.jsxText('');
    }
    if (!node.arguments[0])
        return types.jsxText('');
    var tagName = types.jsxIdentifier(path.get("arguments.0").toString().replace(/"|'/gi, ""));
    var attrs = [];
    if (types.isObjectExpression(node.arguments[1])) {
        var attrobj = node.arguments[1];
        attrobj.properties.forEach(function (attr) {
            if (!types.isObjectProperty(attr))
                return;
            attrs.push(types.jsxAttribute(types.jsxIdentifier(attr.key.name || attr.key.value), types.jsxExpressionContainer(attr.value)));
        });
    }
    var childrens = [];
    if (node.arguments.length > 2) {
        childrens = node.arguments.slice(2).map(function (item, index) {
            if (types.isCallExpression(item)) {
                if (!path.get("arguments." + (index + 2)).toString().endsWith('createElement')) {
                    return types.jsxExpressionContainer(item);
                }
                return dg(item);
            }
            else if (types.isStringLiteral(item)) {
                if (tagName.name == "style") {
                    attrs.push(types.jsxAttribute(types.jsxIdentifier("dangerouslySetInnerHTML"), item));
                    return types.jsxText("");
                }
                else {
                    return types.jsxText(item.value);
                }
            }
            else if (types.isExpression(item) && !types.isObjectExpression(item)) {
                return types.jsxExpressionContainer(item);
            }
        });
    }
    if (childrens.length <= 0) {
        return types.jsxElement(types.jsxOpeningElement(tagName, attrs, true), null, [], true);
    }
    return types.jsxElement(types.jsxOpeningElement(tagName, attrs), types.jsxClosingElement(tagName), childrens, false);
}
function default_1(code) {
    var ast = parser_1.parse(code, {
        plugins: ['jsx']
    });
    var opt = {
        CallExpression: function (path, t) {
            if (path.get("callee").toString().endsWith('createElement')) {
                var jsxElement = dg(path);
                if (types.isJSXElement(jsxElement)) {
                    path.replaceWith(jsxElement);
                }
            }
        }
    };
    // @ts-ignore
    traverse_1.default(ast, opt);
    var output = generator_1.default(
    // @ts-ignore
    ast, {
        jsescOption: {
            wrap: true,
            compact: false,
            indent: ' ',
            indentLevel: 2
        }
    }, code);
    return output.code;
}
exports.default = default_1;
//# sourceMappingURL=react.js.map